// A stored Stripe Checkout URL is not proof that the session is still usable.
// When its saved expiry has passed, offer verified regeneration instead.
export const resolveUsableInvoiceCheckoutLink = (invoice = {}, nowMs = Date.now()) => {
  const link = invoice?.checkoutLink || invoice?.checkoutUrl ||
    invoice?.paymentLink || invoice?.stripeCheckoutUrl || '';
  if (!link) return null;
  const expiryRaw = invoice?.linkExpiry;
  if (expiryRaw) {
    const expiry = new Date(expiryRaw).getTime();
    if (Number.isFinite(expiry) && expiry <= nowMs) return null;
  }
  return link;
};
